import { render } from "./VeriGizliligi.vue?vue&type=template&id=2a90e690&scoped=true"
import script from "./VeriGizliligi.vue?vue&type=script&lang=js"
export * from "./VeriGizliligi.vue?vue&type=script&lang=js"

import "./VeriGizliligi.vue?vue&type=style&index=0&id=2a90e690&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a90e690"]])

export default __exports__